export const allMatch = <T>(values: T[], predicate: (value: T) => boolean) => {
  for (const value of values) {
    if (!predicate(value)) {
      return false;
    }
  }

  return true;
};
